import { hydrateQuestionThreads } from '@components/dynamic-form/hydrateQuestionThreads';
import { hydrateQuestionData } from '@src/app-components/dynamic-form/hydrateQuestionData';
import { hydrateSectionData } from '@src/app-components/dynamic-form/hydrateSectionData';
import {
  resolveNonPcnConfigForRequest,
  nonPcnConfigByKey,
  type NonPcnConfig,
} from '@src/app-pages/Forms/registry/configs/nonPcn/nonPcnConfig.ts';
import { RequestType } from '@src/utils/enums';
import { type GetNwpGpPermitTypesOpts } from '@src/api/services/lookup/types';
import { type QuestionList, type QuestionSectionData } from '@components/dynamic-form/types';

const hydrateNonPcnConfig = (config: NonPcnConfig) => {
  hydrateQuestionThreads({
    questionsById: config.questionsById,
    getParentObject: config.getParentObject,
  });

  hydrateQuestionData({
    questionsById: config.questionsById,
    questionNamesById: config.nonPcnQuestionNameById,
  });

  hydrateSectionData({
    sectionsById: config.sectionsById,
  });
};

Object.values(nonPcnConfigByKey).forEach((config) => hydrateNonPcnConfig(config));

export const getNonPcnFormConfig = (formVersion?: number | null) => {
  const activeConfig = resolveNonPcnConfigForRequest({ formVersion });
  const questionsById = activeConfig.questionsById;

  questionsById[1].clearQuestionIdsOnChange = Object.keys(questionsById)
    .map((id) => parseFloat(id))
    .filter((id) => [1, 2, 3, 4, 4.1, 5, 5.1, 6, 6.1, 8, 9, 10, 10.1].indexOf(id) === -1);

  const initNonPcnData = async (opts: GetNwpGpPermitTypesOpts): Promise<QuestionList[]> => {
    questionsById[1].lists = opts;
    return opts;
  };

  const formOneSections = (Object.values(activeConfig.sectionsById) as QuestionSectionData[]).filter(
    (section) => section.formId === 1 && !section.isHeader
  );

  const generalConditionSections = (Object.values(activeConfig.sectionsById) as QuestionSectionData[]).filter(
    (section) => section.formId === 2
  );

  const combinedNonPcnSections = [...formOneSections, activeConfig.sectionsById[36], ...generalConditionSections];

  return {
    questionsById,
    initNonPcnData,
    nonPcnForm: {
      formId: 1,
      formTitle: `${RequestType.NonPreconstructionNotification} Information`,
      sections: combinedNonPcnSections,
      isInformation: false,
      questionsById,
    },
    generalConditionsForm: {
      formId: 2,
      formTitle: `${RequestType.NonPreconstructionNotification} General Conditions`,
      sections: [activeConfig.sectionsById[36], ...generalConditionSections],
      isInformation: false,
      questionsById,
    },
  };
};
